{
  "es": {
    "editor_ziggu": {
      "actions": {
        "apply": "Aplicar",
        "cancel": "Cancelar",
        "link": "Enlace",
        "showLess": "Mostrar menos",
        "showMore": "Mostrar más"
      },
      "labels": {
        "blue": "Azul",
        "green": "Verde",
        "link_text": "Texto del enlace",
        "orange": "Naranja",
        "pink": "Rosa",
        "purple": "Morado",
        "red": "Rojo",
        "remove_highlight": "Quitar resaltado",
        "yellow": "Amarillo"
      },
      "placeholders": {
        "content": "Empieza a escribir..",
        "link": "Escribe o pega un enlace"
      }
    }
  }
}
